module.exports = __webpack_public_path__ + "static/media/eleve-assis.e683927f.png";